<div class="w-full flex items-center"
  *ngrxLet="viewModel$; let model;">
  <mat-form-field appearance="fill"
    class="floatingFilter"
    [class]="model.backgroundClassName">
    <input matInput
      appGxInput
      [readonly]="model.readOnly"
      (click)="showParentFilter()"
      type="text"
      placeholder="{{ 'MULTISELECT.SEARCH' | translate }}"
      [formControl]="inputFormControl"/>
      @if (model.hasValue) {
        <button
          matSuffix
          mat-icon-button
          (click)="resetParentFilter()">
          <mat-icon svgIcon="close" class="closeIcon"></mat-icon>
        </button>
      }
   </mat-form-field>

  <button mat-icon-button
    #filterMenuTrigger
    [matMenuTriggerFor]="filterMenu"
    [matTooltip]="getLocationsWithUpdatesTooltip()"
    class="filterLocationIdsButton"
    [disabled]="model.loading"
  >
    @if (!model.loading) {
      <mat-icon svgIcon="update" class="text-neutral-10"/>
    }
    @if (model.loading) {
      <mat-spinner [diameter]="24"></mat-spinner>
    }
  </button>
</div>


<mat-menu #filterMenu>
  <ng-template matMenuContent>
    <app-recent-update-filter [headerName]="params.filterParams.colDef.headerName"
                              [field]="params.filterParams.colDef.field"
                              (closeFilterMenu)="closeFilterMenu()"/>
  </ng-template>

</mat-menu >



